import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/page/home/Home'
import College from '@/page/college/College'
import CollegeDetail from '@/page/college/CollegeDetail'
import CollegeSpeaker from '@/page/college/CollegeSpeaker'
import Association from '@/page/association/Association'
import AssociationRunning from '@/page/association/AssociationRunning'
import Activity from '@/page/activity/Activity'
import ActivityDetail from '@/page/activity/ActivityDetail'
import PartyDetail from '@/page/activity/PartyDetail'
import Periphery from '@/page/periphery/Periphery'
import About from '@/page/about/About'
import Agreement from '@/page/about/Agreement'
import Founder from '@/page/about/Founder'
import AboutBusiness from '@/page/about/AboutBusiness'
import AboutJoinUs from '@/page/about/AboutJoinUs'

const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/college',
      name: 'college',
      component: College
    },
    {
      path: '/association',
      name: 'association',
      component: Association
    },
    {
      path: '/associationRunning',
      name: 'associationRunning',
      component: AssociationRunning
    },
    {
      path: '/activity',
      name: 'activity',
      component: Activity
    },
    {
      path: '/periphery',
      name: 'periphery',
      component: Periphery
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/collegeDetail',
      name: 'collegeDetail',
      component: CollegeDetail
    },
    {
      path: '/collegeSpeaker',
      name: 'collegeSpeaker',
      component: CollegeSpeaker
    },
    {
      path: '/activityDetail',
      name: 'activityDetail',
      component: ActivityDetail
    },
    {
      path: '/partyDetail',
      name: 'partyDetail',
      component: PartyDetail
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: Agreement
    },
    {
      path: '/founder',
      name: 'founder',
      component: Founder
    },
    {
      path: '/aboutBusiness',
      name: 'aboutBusiness',
      component: AboutBusiness
    },
    {
      path: '/aboutJoinUs',
      name: 'aboutJoinUs',
      component: AboutJoinUs
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    console.log(savedPosition)
    if(savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js